import { InjectionKey } from 'vue'
import { createStore, Store, useStore as baseUseStore } from 'vuex'
import { vuexLocalStore } from '@gd/storage'
import { actions } from './actions'
import { mutations } from './mutations'
import { state, State, StoreState } from './state'
import { getters, Getters } from './getters'
import history from './modules/history'
import join from './modules/join'
import lobbyTimers from './modules/lobbyTimers'
import ranking from './modules/ranking/index'
import matching from './modules/matching'
import results from './modules/results'
import winningDistribution from './modules/winningDistribution'

// define injection key
export const key: InjectionKey<Store<State>> = Symbol()

export const store = createStore({
  strict: true,
  modules: {
    history,
    join,
    lobbyTimers,
    matching,
    ranking,
    results,
    vuexLocalStore,
    winningDistribution,
  },
  state: state as State,
  getters,
  mutations,
  actions,
})

// type State = TournamentHistoryState | _State | ResultState

// define your own `useStore` composition function
// see also: https://vuex.vuejs.org/guide/typescript-support.html#typing-usestore-composition-function
export function useStore() {
  return baseUseStore(key)
}

/**
 * can be used to easy cast the store and have access to all properties
 *
 * Used by the unit tests
 */
export interface $Store extends Store<State> {
  getters: Getters
}
